import { SearchOutlined } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import styles from "./TopNav.module.css";
import MapSwitch from "../MapSwitch";


export const TopNavDash = () => {
    return (
        <div className={styles.searchbar}>
            <div style={{ maxWidth: 300 }}>
                <TextField
                    variant="standard"
                    size="medium"
                    placeholder="Search..."
                    sx={{ width: 300 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                <SearchOutlined
                                    sx={{ color: "var(--secondary-2)" }}
                                    fontSize="18px"
                                />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
    
            <div className="flex-row-direction gap-4 justify-content-end">
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/stats.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/share.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/file.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
            </div>
        </div>
    );
};

export const TopNav = ({
    getMap1,
    currentMapType,
    currentMapTypeIndex,
    clearContour,
    currMapData,
    selectOrthoRef,
    style,
}) => {
    return (
        <div className={styles.searchbar}>
            <div style={{ maxWidth: 300 }}>
                <TextField
                    variant="standard"
                    size="small"
                    placeholder="Search..."
                    sx={{ width: 300 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                <SearchOutlined
                                    sx={{ color: "var(--secondary-2)" }}
                                    fontSize="18"
                                />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div style={{position:"absolute", zIndex:2, left:"50%", top:"50%", translate:"-50% -50%"}}>
                <MapSwitch
                    getMap1={getMap1}
                    currentMapType={currentMapType}
                    currentMapTypeIndex={currentMapTypeIndex}
                    clearContour={clearContour}
                    currMapData={currMapData}
                    selectOrthoRef={selectOrthoRef}
                    style={{ left: "50%", top: "50%", translate:"-50%, -50%" }}
                />
            </div>
            <div className="flex-row-direction gap-4 justify-content-end">
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/stats.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/share.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
                <div style={{ width: "1.5%" }}>
                    <img
                        src="/assets/icons/file.png"
                        width="100%"
                        alt="stats"
                    />
                </div>
            </div>
        </div>
    );
};

